export default __webpack_public_path__ + "static/media/Footsteps of the Void.1e0c9c37.jpg";